export default __webpack_public_path__ + "static/media/extraBtnRedX.23e88cd6.svg";